import { Box, FormControl, FormControlLabel, Switch, TextField } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';
import FormError from '../../form-error/FormError';

export interface AttemptsFieldProps {
  control: Control<any>;
  name: string;
}

const AttemptsField = ({ control, name }: AttemptsFieldProps) => {
  const {
    field: { value: limitNumberOfAttempts, ...limitField },
    fieldState: { error: limitError },
  } = useController({
    control,
    name: 'limitNumberOfAttempts',
  });

  const {
    field,
    fieldState: { error },
    formState,
  } = useController({
    control,
    name,
    rules: {
      validate: {
        required: value => !limitNumberOfAttempts || !!value || 'Please fill in a number between 1 and 1000',
        pattern: value =>
          !limitNumberOfAttempts || /^-?[0-9]*$/.test(value) || 'Please enter a value between 1 and 1000 pattern',
        min: value => !limitNumberOfAttempts || +value >= 1 || 'Please enter a value between 1 and 1000 min',
        max: value => !limitNumberOfAttempts || +value <= 1000 || 'Please enter a value between 1 and 1000 max',
      },
    },
  });

  return (
    <Box display="flex" alignItems={{ sm: 'center' }} flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
      <FormControl error={!!limitError} sx={{ flex: 1 }}>
        <FormControlLabel
          control={<Switch checked={limitNumberOfAttempts} {...limitField} />}
          label="Limit number of simulations"
          sx={{ textAlign: 'left' }}
        />
      </FormControl>
      <FormControl fullWidth error={!!error} sx={{ flex: 1 }}>
        <TextField
          {...field}
          disabled={!limitNumberOfAttempts}
          error={limitNumberOfAttempts && !!error}
          inputProps={{
            inputMode: 'numeric',
            max: '1000',
            min: '1',
            pattern: '[0-9]*',
          }}
          label="Maximum number of simulations"
          placeholder="1 to 1000"
          type="number"
        />

        <FormError name="maxNumberOfAttempts" formState={formState} />
      </FormControl>
    </Box>
  );
};

export default AttemptsField;
